import { useEffect } from 'react';
import { useLoading } from '../context/LoadingContext';

interface UseApiLoaderOptions {
  message?: string;
  showProgress?: boolean;
  enableSound?: boolean;
}

export const useApiLoader = (
  isLoading: boolean,
  options: UseApiLoaderOptions = {}
) => {
  const { showLoader, hideLoader, updateProgress, updateMessage } = useLoading();
  const { message = 'Loading Data', showProgress = false, enableSound = true } = options;

  useEffect(() => {
    if (isLoading) {
      showLoader(message, showProgress, 0);
    } else {
      hideLoader();
    }
  }, [isLoading, message, showProgress, showLoader, hideLoader]);

  return {
    updateProgress,
    updateMessage,
  };
};

// Hook for RTK Query loading states
export const useRtkQueryLoader = (
  isLoading: boolean,
  isFetching: boolean = false,
  options: UseApiLoaderOptions = {}
) => {
  const { showLoader, hideLoader, updateProgress, updateMessage } = useLoading();
  const { message = 'Loading Data', showProgress = false, enableSound = true } = options;

  useEffect(() => {
    if (isLoading || isFetching) {
      showLoader(message, showProgress, 0);
    } else {
      hideLoader();
    }
  }, [isLoading, isFetching, message, showProgress, showLoader, hideLoader]);

  return {
    updateProgress,
    updateMessage,
  };
}; 